import classes from "./style.module.scss";
import { RiMessage2Line } from "react-icons/ri";
import { navconfig } from "../../_navElement";
import { useNavigate } from "react-router-dom";
import {
	CLIENT_ADMINISTRATOR,
	USER,
	SYSTEM_ADMINISTRATOR,
} from "../../../../utils/constants";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentTab } from "../../../../redux/ducks/auth";

const TopbarIPad = () => {
	const { userRole, currentTab } = useSelector(state => state.auth);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const getMenuItem = role => {
		if (role === USER) return navconfig.user.items;
		if (role === CLIENT_ADMINISTRATOR) return navconfig.Org_Admin.items;
		if (role === SYSTEM_ADMINISTRATOR) return navconfig.Sys_Admin.items;
	};
	const MenuItemList = getMenuItem(userRole);

	const currentTabStyle = e => {
		if (e === currentTab) {
			return customStyles.navItemChecked;
		} else {
			return customStyles.navItem;
		}
	};
	return (
		<div className={classes["nav-tabs-ipad"]}>
			{MenuItemList?.map(({ label, to }, index) => {
				return (
					<div
						key={index}
						onClick={() => {
							dispatch(setCurrentTab(index));
							navigate(to);
						}}
						style={currentTabStyle(index)}>
						<RiMessage2Line style={customStyles.icons} />
						&nbsp;{label}
					</div>
				);
			})}
		</div>
	);
};

export default TopbarIPad;

const customStyles = {
	navItem: {
		backgroundColor: "white",
		color: "gray",
		height: "max-content",
		width: "13rem",
		padding: "0.5rem",
		textAlign: "center",
		borderBottom: "2px solid white",
		cursor: "pointer",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		margin: "0 1rem",
	},
	navItemChecked: {
		backgroundColor: "#38d0d0",
		color: "white",
		width: "13rem",
		padding: "0.5rem",
		textAlign: "center",
		height: "max-content",
		borderBottom: "2px solid #38d0d0",
		cursor: "pointer",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		margin: "0 1rem",
	},
	avatar: {
		width: "5rem",
		height: "5rem",
	},
	icons: {
		fontSize: "1.2rem",
	},
};
